module.exports = __webpack_public_path__ + "static/media/2. Manage private requests.f6b163d0.svg";